module.exports = __webpack_public_path__ + "static/media/test9_4.98097c07.png";